import LabelBox from "~/domains/salesCampaign/components/LabelBox/LabelBox";
import { useTranslation } from "react-i18next";
import { Typography, type TypographyProps } from "~/common/mui";

interface Props {
  className?: string;
  quantity: number;
}

/**
 * @deprecated Use SaleQuantityIndicator.V2 instead
 */
export const SaleQuantityIndicator = ({ quantity, className }: Props) => {
  const soldOut = quantity === 0;
  const color = soldOut ? "inactive" : "active";
  const { t } = useTranslation();
  let label: string;
  if (soldOut) {
    label = t("feature.salesCampaign.indicator.qty.soldOut");
  } else {
    label = t("feature.salesCampaign.indicator.qty.remaining", { quantity });
  }
  return (
    <LabelBox variant={color} className={className}>
      {label}
    </LabelBox>
  );
};

type V2Props = Props & Pick<TypographyProps, "variant" | "sx">;

const V2 = ({ quantity, variant = "labelLarge", sx: externalSx, ...rest }: V2Props) => {
  const soldOut = quantity === 0;
  const { t } = useTranslation();
  let label: string;
  if (soldOut) {
    label = t("feature.salesCampaign.indicator.qty.soldOut");
  } else {
    label = t("feature.salesCampaign.indicator.qty.remaining", { quantity });
  }

  const color = soldOut ? "disabled" : "salesCampaign";
  const sx = {
    fontWeight: 500,
    ...externalSx,
  };
  return (
    <Typography variant={variant} color={color} sx={sx} {...rest}>
      {label}
    </Typography>
  );
};

SaleQuantityIndicator.V2 = V2;
